import React from 'react'
import Container from 'components/common/Container'
import Heading from 'components/common/Heading'
import SearchBooks from './SearchBooks'

import { GiCheckMark } from 'react-icons/gi';

const SearchBooksAPI = () => {
  return (
    <Container className="py-4">
      <section>
        <Heading className="mb-4">
          2. Search API
        </Heading>

        <div className="mb-4">
            <p className="mb-2">
              http://openlibrary.org/search.json?title=snow+crash
            </p>

            <ul className="mb-2">
              <li>
                <span className="flex items-center">
                  Input box for searching <GiCheckMark className="text-green-500 ml-1" />
                </span>
              </li>
              <li>
                <span className="flex items-center">
                  List all the covers with titles for the books <GiCheckMark className="text-green-500 ml-1" />
                </span>
              </li>
              <li>
                <span className="flex items-center">
                  Cover image should be large, but put a circle mask over it. <GiCheckMark className="text-green-500 ml-1" />
                </span>
              </li>
              <li>
                Notes
                Search for cover, display first
              </li>
            </ul>
        </div>
      </section>

      <section>
        <Heading as="h3">
          Solution
        </Heading>

        <SearchBooks />
      </section>


    </Container>
  )
}

export default SearchBooksAPI